<h1>Tango Ledger</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (tab of tabs | visibleFinanceTabs; track tab) {
    <a mat-tab-link [routerLink]="tab.link" [active]="tab.id === 'tango-ledger'">{{tab.title}}</a>
  }
</nav>
<mat-tab-nav-panel #tabPanel>
  <p>Gift card purchases and funding in one account history. Dates are shown in UTC.</p>
  <form class="filters" (ngSubmit)="apply()">
    <label>From date <input type="date" name="from" [(ngModel)]="from" [disabled]="loading"></label>
    <label>Through date <input type="date" name="to" [(ngModel)]="to" [disabled]="loading"></label>
    <label>Transaction type
      <select name="type" [(ngModel)]="type" [disabled]="loading">
        <option value="all">All transactions</option><option value="purchases">Purchases</option>
        <option value="funding">Funding</option><option value="other">Other</option>
      </select>
    </label>
    <button mat-raised-button color="primary" type="submit" [disabled]="loading">Apply filters</button>
    <button mat-stroked-button type="button" (click)="exportCsv()" [disabled]="loading || exporting || !report || !report.summary.total">{{exporting ? 'Exporting…' : 'Export filtered CSV'}}</button>
  </form>
  @if (error) {
    <p role="alert" class="error">{{error}}</p>
  }
  @if (loading && !report) {
    <p role="status">Loading Tango ledger…</p>
  }
  @if (report; as data) {
    <section aria-label="Tango account report">
      <p class="account">{{data.environment === 'qa' ? 'QA sandbox' : 'Production'}} · Account {{data.account}} · {{data.currencyCode}}</p>
      <div class="notice" role="note">
        <strong>{{data.summary.simulated ? 'Includes a simulated opening deposit.' : 'Opening funding has not been reconciled.'}}</strong>
        Balances describe the imported history and are not verified against Tango funding records.
        @if (data.summary.simulated) {
          <span>Completed imported orders are treated as charges against the simulated opening deposit.</span>
        }
        @if (data.summary.unresolvedCount) {
          <span> {{data.summary.unresolvedCount}} movement(s) remain unresolved; affected balances are unknown.</span>
        }
      </div>
      <div class="summary">
        <div><span>Filtered credits</span><strong>{{money(data.summary.creditsMinor)}}</strong></div>
        <div><span>Filtered debits</span><strong>{{money(data.summary.debitsMinor)}}</strong></div>
        <div><span>Known filtered fees</span><strong>{{money(data.summary.feesMinor)}}</strong>@if (data.summary.unknownFeeCount) {
        <small>{{data.summary.unknownFeeCount}} fee(s) unknown</small>
      }</div>
      <div><span>Modeled opening balance</span><strong>{{money(data.summary.openingBalanceMinor)}}</strong></div>
      <div><span>Modeled closing balance</span><strong>{{money(data.summary.closingBalanceMinor)}}</strong></div>
    </div>
    <p class="hint">Balances include all earlier account activity, regardless of the type filter or display order. Credits, debits and fees reflect the full filtered report.</p>
    @if (!data.summary.total) {
      <p role="status">No Tango transactions match these filters.</p>
    }
    @if (data.rows.length) {
      <div class="table-scroll" infiniteScroll [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="100" [scrollWindow]="false" [infiniteScrollDisabled]="loading || !data.hasMore || !!error"
        (scrolled)="loadMore()" tabindex="0" role="region" aria-label="Scrollable Tango transactions">
        <table>
          <caption class="sr-only">Tango transactions, sorted by {{sort}}, {{direction === 'desc' ? 'descending' : 'ascending'}}</caption>
          <thead><tr><th scope="col" [attr.aria-sort]="sortAria('date')"><button class="sort-header" type="button" (click)="sortBy('date')">Date (UTC) <span aria-hidden="true">{{sortIcon('date')}}</span></button></th><th scope="col" [attr.aria-sort]="sortAria('transaction')"><button class="sort-header" type="button" (click)="sortBy('transaction')">Transaction <span aria-hidden="true">{{sortIcon('transaction')}}</span></button></th><th scope="col">Reference</th><th scope="col" class="money" [attr.aria-sort]="sortAria('amount')"><button class="sort-header" type="button" (click)="sortBy('amount')">Amount <span aria-hidden="true">{{sortIcon('amount')}}</span></button></th><th scope="col" class="money">Fee</th><th scope="col" class="money">Balance effect</th><th scope="col" class="money">Modeled balance</th><th scope="col">Basis</th></tr></thead>
          <tbody>@for (row of data.rows; track trackRow($index, row)) {
            <tr>
              <td class="nowrap">{{row.occurredAt | date:'yyyy-MM-dd HH:mm:ss':'UTC'}}</td>
              <td>{{row.basis === 'Imported order charge' ? 'Gift card purchase' : row.description}}@if (row.simulated) {
                <span class="badge">Simulated</span>
              }</td>
              <td>{{row.reference || '—'}}</td><td class="money">{{money(row.amountMinor)}}</td><td class="money">{{money(row.feeMinor)}}</td>
              <td class="money">{{money(row.balanceEffectMinor)}}</td><td class="money">{{money(row.runningBalanceMinor)}}</td><td>{{row.basis}}</td>
            </tr>
          }</tbody>
        </table>
      </div>
    }
    @if (data.summary.total) {
      <p role="status">Showing {{data.rows.length}} of {{data.summary.total}} transactions@if (loading) {
        <span> · Loading more…</span>
      }</p>
    }
    @if (error && data.hasMore) {
      <button mat-stroked-button type="button" (click)="loadMore()" [disabled]="loading">Retry loading more</button>
    }
  </section>
}
</mat-tab-nav-panel>
